import { render, staticRenderFns } from "./ListNotasInseridasMonthlyView.vue?vue&type=template&id=38cc00cb&"
import script from "./ListNotasInseridasMonthlyView.vue?vue&type=script&lang=ts&"
export * from "./ListNotasInseridasMonthlyView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports